import React from 'react';

const Home = (props) => {
  console.log('pdfList: ', props.pdfList);
  return (  
    <div
    style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '85vh'
    }}
    > 
    {props.pdfList}   
    </div>  
  );
};

export default Home;